export const getUserInfo = state => state.getUserInfo



// WEBPACK FOOTER //
// ./src/store/getters.js